import { render, staticRenderFns } from "./RootContrattiDaFirmareView.vue?vue&type=template&id=b5151744&"
import script from "./RootContrattiDaFirmareView.vue?vue&type=script&lang=ts&"
export * from "./RootContrattiDaFirmareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports